<ion-content forceOverscroll="false">
  <app-header [fixedTitle]="true">
    <app-toolbar [title]="'lbl_edit_form' | translate">
      <app-toolbar-button [text]="'lbl_cancel' | translate" slot="start" (click)="cancel()"></app-toolbar-button>
    </app-toolbar>
  </app-header>

  <main hasFooter>
    <p class="consent-description">{{ 'lbl_rgpd_channels_description' | translate }}</p>

    <div class="channels-header">
      <span class="channels-title">{{ 'app_privacy_policy_accept_2' | translate }}</span>
      <button class="accept-all-btn" (click)="acceptAll()">{{ 'app_accept_all' | translate }}</button>
    </div>

    <div class="communication-channels">
      <ion-checkbox labelPlacement="end" justify="start" [checked]="userEnableEmail" (ionChange)="userEnableEmail = !userEnableEmail">
        <span class="checkbox-text">{{ 'lbl_email_rgpd' | translate }}</span>
      </ion-checkbox>
      <ion-checkbox labelPlacement="end" justify="start" [checked]="userEnableSms" (ionChange)="userEnableSms = !userEnableSms">
        <span class="checkbox-text">{{ 'lbl_sms_rgpd' | translate }}</span>
      </ion-checkbox>
      <ion-checkbox labelPlacement="end" justify="start" [checked]="userEnableApp" (ionChange)="userEnableApp = !userEnableApp">
        <span class="checkbox-text">{{ 'lbl_app_rgpd' | translate }}</span>
      </ion-checkbox>
      <ion-checkbox labelPlacement="end" justify="start" [checked]="userEnableWhatsApp" (ionChange)="userEnableWhatsApp = !userEnableWhatsApp">
        <span class="checkbox-text">{{ 'lbl_whatsapp_rgpd' | translate }}</span>
      </ion-checkbox>
      <ion-checkbox labelPlacement="end" justify="start" [checked]="userEnablePhone" (ionChange)="userEnablePhone = !userEnablePhone">
        <span class="checkbox-text">{{ 'lbl_phone_rgpd' | translate }}</span>
      </ion-checkbox>
      <ion-checkbox labelPlacement="end" justify="start" [checked]="userEnablePostal" (ionChange)="userEnablePostal = !userEnablePostal">
        <span class="checkbox-text">{{ 'lbl_postal_rgpd' | translate }}</span>
      </ion-checkbox>
    </div>
  </main>

  <app-footer>
    <app-button expanded (click)="save()">{{ 'lbl_save_view' | translate }}</app-button>
  </app-footer>
</ion-content>
